import React from 'react';

const SwitchField = ({
  children,
  title,
  ...props
}) => (
  <div className="company-switch-container" {...props}>
    <p style={{ display: 'flex', alignItems: 'center' }}>
      {title}
    </p>
    {' '}
    {children}
  </div>
);

export default SwitchField;
